/*! Gumus 1.0.1 | Developed by Mohamed Shaheen. Preserve the customer's collection journey. */
(() => {
  'use strict';
  const key = 'gumus:collection-return:v1', ttl = 5 * 60 * 1000;
  const origin = location.origin;
  function collectionURL(value) {
    try {
      const url = new URL(value, origin);
      if (url.origin !== origin || !/^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?collections\/[^/]+\/?$/.test(url.pathname)) return null;
      for (const name of [...url.searchParams.keys()]) if (!(name.startsWith('filter.') || ['sort_by','page','preview_theme_id'].includes(name))) url.searchParams.delete(name);
      url.hash = ''; return url.href;
    } catch (_) { return null; }
  }
  function productPath(value) {
    try { const url=new URL(value,origin);return url.origin === origin && /\/products\/[^/]+\/?$/.test(url.pathname) ? url.pathname : null; } catch (_) { return null; }
  }
  function read() {try {const value=JSON.parse(sessionStorage.getItem(key));return value && Date.now()-value.time<ttl && Date.now()>=value.time && collectionURL(value.url)===value.url ? value : null;} catch (_) {return null;}}
  const page = document.querySelector('.collection-page'), grid = page?.querySelector('.collection-products');
  const current = collectionURL(location.href), stored = read();
  if (page && grid && current) {
    // Restore only an actual return/reload of this history entry, never an unrelated new visit.
    if (stored?.url === current && (history.state?.gumusCollection === current || productPath(document.referrer) === stored.product)) {
      if (stored.count > grid.children.length && typeof stored.cards === 'string' && stored.cards.length < 700000) {
        const template=document.createElement('template');template.innerHTML=stored.cards;
        const cards=[...template.content.children].filter(el=>el.matches('.product-card'));
        if (cards.length === stored.count) {
          grid.replaceChildren(...cards);
          const more=page.querySelector('[data-collection-more]');
          if (more && stored.next) more.href=stored.next;
          else if (more && stored.next === null) more.remove();
          document.dispatchEvent(new CustomEvent('gumus:cards-rendered'));
        }
      }
      requestAnimationFrame(()=>requestAnimationFrame(()=>window.scrollTo(0,Math.max(0,Number(stored.y)||0))));
    }
    document.addEventListener('click', event => {
      const link=event.target.closest('.collection-products .product-card a[href]');
      if (!link || !grid.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0 || link.target === '_blank') return;
      const product=productPath(link.href);if (!product) return;
      try {
        const cards=grid.innerHTML;
        sessionStorage.setItem(key,JSON.stringify({url:current,product,time:Date.now(),y:window.scrollY,count:grid.children.length,cards:cards.length<700000?cards:'',next:page.querySelector('[data-collection-more]')?.href || null}));
        history.replaceState({...history.state,gumusCollection:current},'',location.href);
      } catch (_) { /* Native links and collection referrers remain usable when storage is unavailable. */ }
    },true);
  }
  const back=document.querySelector('.product-back'), referrer=collectionURL(document.referrer);
  if (back && referrer) {
    // Never send direct ad visitors back to an external referrer or a previous customer's journey.
    back.href=stored?.product === productPath(location.href) && stored.url === referrer ? stored.url : referrer;
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest('[data-product-details]');if (!link) return;
    const details=document.getElementById('ProductDetails');if (!details) return;
    event.preventDefault();details.open=true;
    details.scrollIntoView({behavior:'auto',block:'start'});
    const summary=details.querySelector('summary');summary?.focus({preventScroll:true});
  });
})();
